import { PricingStatus } from '@edgebox/data-definitions';
import React from 'react';
import { Badge, BadgeBg } from '@edgebox/react-components';
import { DataDefinitionsEnumValue } from '../../Localization/DataDefinitionsEnumValue';

interface IProps {
  status: PricingStatus;
  size?: 'small';
}

export class PricingStatusBadge extends React.Component<IProps, {}> {
  render(): React.ReactElement {
    const { status, size } = this.props;

    const classes = size ? 'small' : '';

    const variants: Record<string, BadgeBg> = {
      [PricingStatus.Active]: 'primary',
      [PricingStatus.Retired]: 'warning',
    };

    return (
      <Badge bg={variants[status]} className={classes}>
        <DataDefinitionsEnumValue enumName={'PricingStatus'} keyName={status} />
      </Badge>
    );
  }
}
